export const colSpanStyle = {
  'font-size': '12px',
  color: '#b3c0d1',
  'user-select': 'none'
}
